import EditableFormattedMessage from "./EditableFormattedMessage";
import messagesData from "../lang/preferences";

export default function ValueHierarchyPages({ messages, locale, updateMessage, graph, keyPage, code, datePassed }) {
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
      </div>
      <div className="report-alt-page">
        <h1>
          <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPEREPORT_VALUEPREFERENCES2" messages={messages} updateMessage={updateMessage} />
          <span className="inline font-16">
            {" "}
            - <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="DEFINITIONS" messages={messages} updateMessage={updateMessage} />
          </span>
        </h1>
        <br />
        <table className="scope-table-fullwidth">
          <tbody>
            {/* Power */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_POWER" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_POWER_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Success */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SUCCESS" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SUCCESS_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Morality */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_MORALITY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_MORALITY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Honor */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_HONOR" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_HONOR_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Affection */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_AFFECTION" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_AFFECTION_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Harmony */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_HARMONY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_HARMONY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="PAGE" messages={messages} updateMessage={updateMessage} /> {keyPage + 1}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="CANDIDATE" messages={messages} updateMessage={updateMessage} />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="TEST_DATE" messages={messages} updateMessage={updateMessage} />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}